<template>
  <div class="popup">
    <div class="form popup__content">
      <div class="form__row loader-container" v-if="areArenasLoading">
           <Loader></Loader>
      </div>
      <div class="form__row" v-if="!areArenasLoading">
        <h2 class="main-title">Arenas, on which feed '{{chosenFeed}}' enabled</h2>
        <ul class="feed-arenas-list">
          <li class="feed-arenas-list__item"
              v-for="(arena, i) in arenas"
              :key="arena.name + i">
            <p><strong>{{arena.name}}</strong></p>
            <p><a v-bind:href="arena.domain" target="_blank">{{arena.domain}}</a></p>
          </li>
        </ul>
      </div>
      <div class="form__row popup__btns-row">
        <button class="ark-btn ark-btn--default" @click="$emit('close')">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Loader from '../../Loader/Loader.vue'
  import config from '../../../config'

  export default {
    name: 'FeedOnArenasPopup',
    props: ['chosenFeed'],
    components: {Loader},
    data () {
      return {
        arenas: [],
        areArenasLoading: false
      }
    },
    created: function () {
      this.getArenasOnFeed()
    },
    methods: {
      getArenasOnFeed: function () {
        this.areArenasLoading = true

        this.$http.get(`${config.apiUrl}/feed/arena/get?feedName=${this.chosenFeed}`)
          .then(response => {
            this.arenas = response.body
            this.areArenasLoading = false
          }, error => {
            console.log(error)
            this.areArenasLoading = false
          })
      }
    }
  }
</script>

<style scoped src="./FeedOnArenasPopup.scss"  lang="scss">

</style>
